import React, { useEffect, useCallback } from 'react'
import useStore from '../../../stores/useStore'
import { DimensionReportAPI } from '../structure/structureOverviewPreviewReport'
import useExportReportOverviewPDF from './useExportReportOverviewPDF'
// import _maxBy from 'lodash/maxBy'
import html2canvas from 'html2canvas'
import useExportReportOverviewExcel from './useExportReportOverviewExcel'
import useDidMountEffect from '../../../hooks/useDidMountEffect'
import useExportFullReportOverviewPDF from './useExportFullReportOverviewPDF'

type UseOverviewPreviewReportPDF = { fromUrl: boolean }
const useOverviewPreviewReport = (props: UseOverviewPreviewReportPDF) => {
    const { fromUrl } = props
    const { downloadPdf, openPdf, isLoadingDownloadPdf, isLoadingOpenPdf } = useExportReportOverviewPDF({})
    const { downloadExcel, isLoadingDownloadExcel } = useExportReportOverviewExcel()

    const {
        downloadFullReportPdf,
        openFullReportPdf,
        isLoadingDownloadFullReportPdf,
        isLoadingOpenFullReportPdf,
        openFullReportPdfSamePage,
    } = useExportFullReportOverviewPDF({ fromUrl: fromUrl })

    const { lookupStore, loadingStore } = useStore()

    useEffect(() => {
        ;(async () => {
            await lookupStore.getLookupQuestionnaireGrade()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useDidMountEffect(() => {
        setTimeout(() => {
            loadingStore.setLoading(
                isLoadingDownloadPdf ||
                    isLoadingOpenPdf ||
                    isLoadingDownloadExcel ||
                    isLoadingDownloadFullReportPdf ||
                    isLoadingOpenFullReportPdf,
            )
        }, 1000)
    }, [
        isLoadingDownloadPdf,
        isLoadingOpenPdf,
        isLoadingDownloadExcel,
        isLoadingDownloadFullReportPdf,
        isLoadingOpenFullReportPdf,
    ])

    // const callGrade = useCallback(
    //     (percent: number) => {
    //         return _maxBy(
    //             lookupStore.questionnaireGrade.filter((item) => item.percent <= percent),
    //             'percent',
    //         )
    //     },
    //     [lookupStore.questionnaireGrade],
    // )

    const reportToClient = useCallback((data: DimensionReportAPI[], questionnaireScore: number) => {
        return data.map(({ purposes, ...dimension }) => {
            const isScoreAdminUndefined = typeof dimension.scoreAdmin === 'undefined'
            const isScoreUserUndefined = typeof dimension.scoreUser === 'undefined'
            const isScoreAdminNull = dimension.scoreAdmin === null
            const isScoreUserNull = dimension.scoreUser === null

            return {
                id: dimension.dimensionID,
                name: `${dimension.dimensionName}`,
                scoreFull:
                    (!isScoreAdminUndefined && !isScoreAdminNull) || (!isScoreUserUndefined && !isScoreUserNull)
                        ? questionnaireScore
                        : '-',
                scoreUser: dimension.scoreUser,
                scoreAdmin: dimension.scoreAdmin,
                descriptionAdmin: dimension.descriptionAdmin,
                descriptionUser: dimension.descriptionUser,
                dimensionOrder: dimension.dimensionOrder,
                // gradeAdmin:
                //     typeof dimension.scoreAdmin === 'number'
                //         ? callGrade((dimension.scoreAdmin * 100) / questionnaireScore)?.grade
                //         : null,
                // gradeUser:
                //     typeof dimension.scoreUser === 'number'
                //         ? callGrade((dimension.scoreUser * 100) / questionnaireScore)?.grade
                //         : null,
                dimensionRef: React.createRef<HTMLElement>(),
                purposes: purposes.map(({ questions, ...purpose }) => {
                    const isScoreAdminUndefined2 = typeof purpose.scoreAdmin === 'undefined'
                    const isScoreUserUndefined2 = typeof purpose.scoreUser === 'undefined'
                    const isScoreAdminNull2 = purpose.scoreAdmin === null
                    const isScoreUserNull2 = purpose.scoreUser === null
                    return {
                        id: purpose.purposeID,
                        name: purpose.purposeName,
                        scoreFull:
                            (!isScoreAdminUndefined2 && !isScoreAdminNull2) ||
                            (!isScoreUserUndefined2 && !isScoreUserNull2)
                                ? questionnaireScore
                                : '-',
                        scoreUser: purpose.scoreUser,
                        scoreAdmin: purpose.scoreAdmin,
                        descriptionAdmin: purpose.descriptionAdmin,
                        descriptionUser: purpose.descriptionUser,
                        purposeOrder: purpose.purposeOrder,
                        // gradeAdmin:
                        //     typeof purpose.scoreAdmin === 'number'
                        //         ? callGrade((purpose.scoreAdmin * 100) / questionnaireScore)?.grade
                        //         : null,
                        // gradeUser:
                        //     typeof purpose.scoreUser === 'number'
                        //         ? callGrade((purpose.scoreUser * 100) / questionnaireScore)?.grade
                        //         : null,
                        questions: questions.map((question) => {
                            return {
                                id: question.questionID,
                                name: question.questionName,
                                value: question.suggestion,
                                autoRecommended: question.autoSuggest,
                                fieldType: question.fieldType,
                                questionOrder: question.questionOrder ? question.questionOrder : null,
                                questionName: question.questionName ? question.questionName : null,
                                questionDescription: question.questionDescription ? question.questionDescription : null,
                                options: question.options ? question.options : [],
                                file: question.file ? question.file : [],
                                link: question.link ? question.link : [],
                                answers: question.answers,
                                suggestionAdmin: question.suggestionAdmin,
                                suggestionUser: question.suggestionUser,
                                answersAdmin: question.answersAdmin,
                                answersUser: question.answersUser,
                            }
                        }),
                    }
                }),
            }
        })
    }, [])

    const getDataToPdf = useCallback(async (dataSource: any[]) => {
        const dataToPdf = await Promise.all(
            dataSource.map(async ({ dimensions, ...questionnaire }) => {
                const imageQuestionnaire = await html2canvas(questionnaire.questionnaireRef.current, {
                    scrollY: window.pageYOffset * -1,
                    height: 600,
                    width: 600,
                    scale: 2,
                })

                const newDimensions = await Promise.all(
                    dimensions.map(async (dimension: any) => {
                        const imageDimension = await html2canvas(dimension.dimensionRef.current, {
                            scrollY: window.pageYOffset * -1,
                            height: 650,
                            width: 650,
                            scale: 2,
                        })
                        return { ...dimension, dimensionRef: imageDimension.toDataURL() }
                    }),
                )
                return {
                    ...questionnaire,
                    questionnaireRef: imageQuestionnaire.toDataURL(),
                    dimensions: newDimensions,
                }
            }),
        )

        return dataToPdf
    }, [])

    const onDownloadPdf = useCallback(
        async ({ data }: { data: any[] }) => {
            const dataToPdf = await getDataToPdf(data)
            downloadPdf({ data: dataToPdf })
        },
        [downloadPdf, getDataToPdf],
    )

    const onOpenPdf = useCallback(
        async ({ data }: { data: any[] }) => {
            const dataToPdf = await getDataToPdf(data)
            openPdf({ data: dataToPdf })
        },
        [getDataToPdf, openPdf],
    )

    const onDownloadExcel = useCallback(
        async ({ data }: { data: any[] }) => {
            const dataToPdf = await getDataToPdf(data)
            downloadExcel({ data: dataToPdf })
        },
        [downloadExcel, getDataToPdf],
    )

    const onDownloadFullReportPdf = useCallback(
        async ({ data }: { data: any[] }) => {
            loadingStore.setLoading(true)
            const dataToPdf = await getDataToPdf(data)
            downloadFullReportPdf({ data: dataToPdf })
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [downloadFullReportPdf, getDataToPdf],
    )

    const onOpenFullReportPdf = useCallback(
        async ({ data }: { data: any[] }) => {
            const dataToPdf = await getDataToPdf(data)
            openFullReportPdf({ data: dataToPdf })
        },
        [getDataToPdf, openFullReportPdf],
    )

    const onOpenFullReportPdfSamePage = useCallback(
        async ({ data }: { data: any[] }) => {
            const dataToPdf = await getDataToPdf(data)
            openFullReportPdfSamePage({ data: dataToPdf })
        },
        [getDataToPdf, openFullReportPdfSamePage],
    )

    return {
        onOpenPdf,
        reportToClient,
        onDownloadPdf,
        onDownloadExcel,
        isLoadingDownloadPdf,
        isLoadingOpenPdf,
        isLoadingDownloadExcel,
        onDownloadFullReportPdf,
        onOpenFullReportPdf,
        isLoadingDownloadFullReportPdf,
        isLoadingOpenFullReportPdf,
        onOpenFullReportPdfSamePage,
    }
}

export default useOverviewPreviewReport
